module.exports = __webpack_public_path__ + "img/robot3_blaster1_akimbo.ff0bc2ca.png";